var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1962 6.67209C20.1962 6.88021 20.1137 7.07981 19.9668 7.22697C19.8199 7.37414 19.6207 7.45681 19.413 7.45681H17.0636C16.8558 7.45681 16.6566 7.53949 16.5098 7.68665C16.3629 7.83382 16.2804 8.03341 16.2804 8.24154V11.3804H19.2407C19.3566 11.3804 19.471 11.4062 19.5757 11.4558C19.6805 11.5055 19.7729 11.5778 19.8464 11.6676C19.9198 11.7574 19.9725 11.8624 20.0006 11.975C20.0286 12.0876 20.0314 12.2051 20.0087 12.319C19.8633 13.0476 19.6658 14.0371 19.5388 14.6731C19.5033 14.851 19.4074 15.0111 19.2674 15.1261C19.1274 15.2412 18.9519 15.304 18.7708 15.304H16.2804V24.7207H12.3646V15.304H10.0151C9.80739 15.304 9.60819 15.2214 9.46132 15.0742C9.31445 14.927 9.23193 14.7274 9.23193 14.5193V12.1651C9.23193 11.957 9.31445 11.7574 9.46132 11.6103C9.60819 11.4631 9.80739 11.3804 10.0151 11.3804H12.3646V8.24154C12.3646 6.99281 12.8596 5.79523 13.7409 4.91224C14.6221 4.02926 15.8173 3.5332 17.0636 3.5332H19.413C19.6207 3.5332 19.8199 3.61588 19.9668 3.76304C20.1137 3.91021 20.1962 4.1098 20.1962 4.31793V6.67209Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.5eb28994b653b60646f2abe2a4cb3a5c.svg";
export { ForwardRef as ReactComponent };